module.exports = __webpack_public_path__ + "dist/banner_01.1290e08d.png";